<template>
	<main class="single page main margin-both-lg" :key="currentPageID">
		<template v-if="!isProtected" >
			<ModuleBuilder />
		</template>
		<PasswordProtection v-else />
	</main>
</template>


<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import PasswordProtection from '@/components/parts/PasswordProtection'

import { mapGetters } from 'vuex';

export default {
	name: 'single-page',
	components:{
		ModuleBuilder,
		PasswordProtection,
	},
	computed: {
        ...mapGetters([
			'currentPage',
			'currentPageID'
        ]),
		isProtected(){
			let isProtected = false;
			if(this.currentPage && this.currentPage.is_protected === true){
				isProtected = true
			}
			return isProtected;
		},
	},
	mounted(){
	}
}
</script>